import React from 'react';


const CardsLinks = () => {
  const cardData = [
    { title: "RGPV", icon: "rgpv1.png", link: "https://www.rgpv.ac.in/" },
    { title: "MP Online", icon: "mponline1.png" , link: "https://www.mponline.gov.in/portal/" },
    { title: "DTE", icon: "dte2.png", link: "https://dte.mponline.gov.in/portal/services/onlinecounselling/counshomepage/home.aspx" },
    { title: "ALCTE", icon: "aicte2.png", link: "https://www.aicte-india.org/" }
  ];

  return (
    <div className="max-w-6xl mx-auto p-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {cardData.map((card, index) => (
        <a 
          key={index}
          href={card.link}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-yellow-50 border border-red-300 shadow-md hover:shadow-lg transition-shadow duration-300 p-4 hover:-translate-y-1 transition-transform"
        >
          <div className="text-center space-y-4">
            <img src={card.icon} className="mx-auto w-24 h-16" alt={card.title} />
          </div>
        </a>
      ))}
    </div>
  );
};

export default CardsLinks;

